// extracted by mini-css-extract-plugin
export default {"root":"xShxOi","topic":"Je2ZUF","inline":"npcLIm","cardContent":"Pw0__L","link":"ZxIi6_"};